<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-toolbar p-component mb-4">
      <warehouseDialog ref="openDialog"/>
      </div>
      
      <warehouseList @edit-warehouse="editWarehouse" @delete-message="deleteWarehouse"/>
  </div>
</section>
</template>
<script>
import warehouseList from './warehouseList.vue'
import warehouseDialog from '../warehouseDialog/warehouseDialog.vue'

export default {
  name: 'warehouse',
  mounted() {
  },
  methods: {
    editWarehouse(data) {
      this.$refs.openDialog.editWarehouse(data)
    },
    deleteWarehouse(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    warehouseList,
    warehouseDialog
  }
}
</script>



// WEBPACK FOOTER //
// Warehouse.vue?5377866b